import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import GradeList from './GradeList';
import GradeForm from './GradeForm';
import DeletedGradesList from './DeletedGradesList';

const Grades = () => {
  return (
    <Routes>
      <Route path="/" element={<GradeList />} />
      <Route path="/new" element={<GradeForm />} />
      <Route path="/:id/edit" element={<GradeForm />} />
      <Route path="/deleted" element={<DeletedGradesList />} />
      <Route path="*" element={<Navigate to="/grades" replace />} />
    </Routes>
  );
};

export default Grades;
